import * as React from 'react'

import { Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import {
  DocumentTemplateDetailsDocument,
  DocumentTemplateDetailsQuery,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type TaskConfigurationSendDocumentTemplate =
  DocumentTemplateDetailsQuery['processes']['taskConfigurationSendDocumentTemplatesConnection']['nodes'][number]

interface Props {
  taskConfigurations?: TaskConfigurationSendDocumentTemplate[]
}

const WorkflowsTag = ({ taskConfigurations }: Props) => {
  const [open, toggle] = useToggle(false)

  const taskConfigurationTitles = taskConfigurations
    ?.map((taskConfiguration) => taskConfiguration.title)
    .join(', ')

  if (!taskConfigurations?.length) return null

  const tooltipText =
    i18n.tp('documents.document_templates.integrations.workflows_used', {
      count: taskConfigurations?.length,
    }) + taskConfigurationTitles

  return (
    <Tooltip.Alt attachment="top center" label={tooltipText} open={open} toggle={toggle}>
      <Tag solid type={Tag.Types.grey5} capitalize>
        {i18n.t('documents.document_templates.integrations.workflows')}
      </Tag>
    </Tooltip.Alt>
  )
}

export default WorkflowsTag
